var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5029 24.0039L10.9954 24.0022L10.9965 22.9845L20.512 22.9909C20.6447 22.991 20.772 22.9384 20.8658 22.8446C20.9597 22.7508 21.0124 22.6236 21.0124 22.4909V7.99182L8.99811 7.99036V24.007H8.00293V7.99414H7V6.99414H11V5.99707H19V6.99414H23V7.99414H22.0039V22.5039C22.004 22.9017 21.8461 23.2832 21.5649 23.5645C21.2836 23.8458 20.9022 24.0039 20.5044 24.0039H20.5029ZM19.0107 9.99372H18.0107V21.0147H19.0107V9.99372ZM13.0411 9.99955H14.0411V21.0205H13.0411V9.99955ZM15.9922 9.99955H16.9922V21.0205H15.9922V9.99955ZM10.998 9.99754H11.998V20.9946H10.998V9.99754Z",
    fill: "#F34041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.48180de8b7e7f1152ca6b578cce701ea.svg";
export { ForwardRef as ReactComponent };